"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultCurrentScope = getDefaultCurrentScope;
exports.getDefaultIsolationScope = getDefaultIsolationScope;

var _scope = require("./scope.js");

var _worldwide = require("./utils-hoist/worldwide.js");

/** Get the default current scope. */
function getDefaultCurrentScope() {
  return (0, _worldwide.getGlobalSingleton)('defaultCurrentScope', () => new _scope.Scope());
}
/** Get the default isolation scope. */


function getDefaultIsolationScope() {
  return (0, _worldwide.getGlobalSingleton)('defaultIsolationScope', () => new _scope.Scope());
}